import { CmsConfig } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';
import { KnBrAsmMainUiComponent } from './kn-br-asm-main-ui/kn-br-asm-main-ui.component';

export const knBrDefaultAsmLayoutConfig: LayoutConfig & CmsConfig = {
  launch: {
    ASM: {
      outlet: 'cx-storefront',
      component: KnBrAsmMainUiComponent,
    },
  },
};
